export interface GetUserLocationModel {
  ip: string;
  countryCode: string;
}
